export class NotificationModel {
    id: number;
    type: number;
    createdBy: number;
    createdDate: Date;
    users: string;
    groups: string;
    relatedEventId: number;
    isReadUsers: string;
}

export enum NotificationType {
    PROCESS = 0,
    SOCIAL_COMMENT_LIKE = 1,  // Yorum beğenisi
    SOCIAL_POST_LIKE = 2,     // Post beğenisi
    BOARD_ADD = 3,
    BOARD_UPDATE = 4,
    BOARD_MESSAGE = 5,
    BOARD_DELETE = 6,
    BOARD_COMPLETE = 7,
    SOCIAL_ADD_POST = 8,
    SOCIAL_ADD_COMMENT = 9,
    SOCIAL_POST_RETWEET = 10,
    PROCESS_OTHER = 11,
    REPOST = 12
}

export enum NotificationAction {
    ADD = 'addedTask',
    UPDATE = 'updatedTask',
    MESSAGE = 'messageAddedToTask',
    DELETE = 'deleteTask',
    COMPLETE = 'completedTask'
}

export enum NotificationTemplate {
    SOCIAL = 'socialToastNotification',
    REPOST = 'repostToastNotification',
    BOARD = 'boardToastNotification'
}

